import React from "react";
import Screen from "./screen";

export default ({
  isOpen,
  onCancel,
  onConfirm,
  message,
  confirmText,
  cancelText,
  textHeader
}) => {
  return (
    <Screen
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
      textHeader={textHeader}
    />
  );
}; 